<template>
  <b-modal
    :id="`class-register-modal${id}`"
    size="lg"
    body-class="reg-modal"
    hide-footer
    @shown="onShown"
    @hidden="onHidden"
  >
    <template v-slot:modal-title>
      <span>{{ trans('register') }}</span>
    </template>
    <class-register
      v-if="!!am_class"
      :organization="organization"
      :am-class="am_class"
      :hideRegButton="hideRegButton"
    ></class-register>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
    <br/>
  </b-modal>
</template>
<style>
@media screen and (max-width: 575px) {
    .modal .modal-dialog .reg-modal{
        padding: 1rem;
    }
}
</style>
<script>
  import ClassRegister from './ClassRegister'

  export default {
    props: {
      organization: Object,
      amClass: Object,
      id: {
        type: String|Number,
        default: '',
      },
      hideRegButton: {
        type: Boolean,
        default: false,
      }
    },
    components: {
      ClassRegister,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        am_class: this.amClass,
      }
    },
    watch: {
      amClass() {
        this.am_class = this.amClass
      },
    },
    methods: {
      onShown() {
        if (!window.classRegisterAmClassId) this.fetch(window.classRegisterAmClassId)
        if (this.amClass) this.am_class = this.amClass
      },
      onHidden() {
        this.am_class = null
      },
      fetch(am_class_id) {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/class/${am_class_id}`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.am_class = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.classRegisterModal = this
    },
  }
</script>
